import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import CheckboxForProducerCodeForm from "components/CheckboxForProducerCodeForm";

const ProducerCodeMapping = ({ producerCodeRow }) => {
  const formMethods = useFormContext();
  const { register, reset, control, setValue } = formMethods;

  const { cdrcStatus, aL3Status, keeperStatus } = producerCodeRow || {};
  const isInactive =
    !formMethods.watch("isActive") && !formMethods.watch("isSuspended");
  const fields = useWatch({ control });

  const canChangeCDRC =
    !isInactive && cdrcStatus !== "True" && fields.carrierId !== 174;
  const canChangeAL3 =
    !isInactive && aL3Status !== "True" && fields.carrierId !== 174;
  const canChangeKeeper =
    !isInactive && keeperStatus !== "True" && fields.carrierId !== 174;

  useEffect(() => {
    reset({
      ...fields,
      isCDRCException:
        cdrcStatus === "Exception" ||
        (fields.carrierId === 174 && fields.status !== "false"),
      isAL3Exception:
        aL3Status === "Exception" ||
        (fields.carrierId === 174 && fields.status !== "false"),
      isKeeperException:
        keeperStatus === "Exception" ||
        (fields.carrierId === 174 && fields.status !== "false"),
    });
  }, []);

  return (
    <>
      <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
        <div className="grid grid-cols-3 w-full items-center gap-2">
          <label className="flex items-stretch text-left expandedLabel fontExpand">
            CDRC Exception:
          </label>

          <CheckboxForProducerCodeForm
            className="border border-gray-300 col-span-2 rounded-sm text-xs focus:ring-quaternary focus:border-quaternary disabled:cursor-not-allowed"
            name="isCDRCException"
            type="checkbox"
            register={register}
            disabled={!canChangeCDRC}
            onClick={({ target: { checked: isChecked } }) => {
              setValue("isCDRCException", isChecked);
            }}
          />
        </div>

        <div className="grid grid-cols-3 w-full items-center gap-2">
          <label className="flex items-stretch text-left expandedLabel fontExpand">
            Keeper Exception:
          </label>

          <CheckboxForProducerCodeForm
            className="border border-gray-300 col-span-2 rounded-sm text-xs focus:ring-quaternary focus:border-quaternary disabled:cursor-not-allowed"
            type="checkbox"
            name="isKeeperException"
            register={register}
            disabled={!canChangeKeeper}
            onClick={({ target: { checked: isChecked } }) => {
              setValue("isKeeperException", isChecked);
            }}
          />
        </div>

        <div className="grid grid-cols-3 w-full items-center gap-2">
          <label className="flex items-stretch text-left expandedLabel fontExpand">
            AL3 Exception:
          </label>

          <CheckboxForProducerCodeForm
            className="border border-gray-300 col-span-2 rounded-sm text-xs focus:ring-quaternary focus:border-quaternary disabled:cursor-not-allowed"
            name="isAL3Exception"
            type="checkbox"
            register={register}
            disabled={!canChangeAL3}
            onClick={({ target: { checked: isChecked } }) => {
              setValue("isAL3Exception", isChecked);
            }}
          />
        </div>
      </div>
      <div className="border-b border-gray-200 mt-2 mb-4"></div>
    </>
  );
};

export default ProducerCodeMapping;
